import {ApiService} from "../../services/api";
import { WorkExperience } from "../../types";
import {AxiosResponse} from "axios";
import {WorkExperienceSendDTO} from "../../types/DTOs/WorkExperienceDTO";

export class WorkExperienceAPI extends ApiService{
    // Work Experience endpoints
    async getWorkExperience(): Promise<WorkExperience[]> {
        const response: AxiosResponse<WorkExperience[]> = await this.api.get('/workexperience');
        return response.data;
    }

    async createWorkExperience(data: WorkExperienceSendDTO): Promise<WorkExperience> {
        const response: AxiosResponse<WorkExperience> = await this.api.post('/workexperience', data);
        return response.data;
    }

    async updateWorkExperience(id: string, data: Partial<WorkExperienceSendDTO>): Promise<WorkExperience> {
        const response: AxiosResponse<WorkExperience> = await this.api.put(`/workexperience/${id}`, data);
        return response.data;
    }

    async deleteWorkExperience(id: string): Promise<void> {
        await this.api.delete(`/workexperience/${id}`);
    }
}